import { __rest } from '../../_virtual/_tslib.js';
import { jsx } from 'react/jsx-runtime';
import { styled, IconButton as IconButton$1, alpha, Skeleton } from '@mui/material';
import { cloneElement } from 'react';

const DEFAULT_BUTTON_SIZE = 24;
const DEFAULT_VARIANT = "high";
const SKELETON_HEIGHT = {
    24: 8,
    36: 12,
};
const ALLOWED_LOADING_SIZES = [24, 36];
/**
 *`IconButton` is a button component intended to be used with custom icon.
 */
function IconButton(_a) {
    var { buttonSize = DEFAULT_BUTTON_SIZE, iconSize, variant = DEFAULT_VARIANT, "data-testid": dataTestId, onClick, children, isLoading } = _a, rest = __rest(_a, ["buttonSize", "iconSize", "variant", "data-testid", "onClick", "children", "isLoading"]);
    if (isLoading && ALLOWED_LOADING_SIZES.includes(buttonSize)) {
        return (jsx(Skeleton, { "data-testid": dataTestId, height: SKELETON_HEIGHT[buttonSize], sx: { borderRadius: SKELETON_HEIGHT[buttonSize] / 2 }, variant: "rectangular", width: buttonSize }));
    }
    const Icon = cloneElement(children, { sx: { fontSize: iconSize !== null && iconSize !== void 0 ? iconSize : buttonSize } });
    return (jsx(StyledIconButton, Object.assign({ "$buttonSize": buttonSize, "$variant": variant, "data-testid": dataTestId, onClick: onClick }, rest, { children: Icon })));
}
const StyledIconButton = styled(IconButton$1)(({ theme, $buttonSize, $variant }) => (Object.assign({ display: "flex", justifyContent: "center", alignItems: "center", width: $buttonSize, height: $buttonSize, padding: 0, borderRadius: theme.shape.borderRadius, "&:focus-visible": {
        boxShadow: "0px 0px 4px 3px rgba(27, 99, 207, 0.30)",
    } }, getColorsByType($variant, theme))));
const getColorsByType = (type = "high", theme) => {
    return {
        white: Object.assign({ color: theme.palette.text.white, backgroundColor: "transparent" }, getColorStatesStyles(theme.palette.text.white)),
        blue: Object.assign({ color: theme.palette.primary.main, backgroundColor: "transparent" }, getColorStatesStyles(theme.palette.primary.main)),
        lightgrey: Object.assign({ color: theme.palette.text.dhigh, backgroundColor: "transparent" }, getColorStatesStyles(theme.palette.text.white)),
        grey: Object.assign({ color: theme.palette.text.dlow, backgroundColor: "transparent" }, getColorStatesStyles(theme.palette.text.white)),
        high: Object.assign({ color: theme.palette.text.high, backgroundColor: "transparent" }, getColorStatesStyles(theme.palette.primary.main)),
        error: Object.assign({ color: theme.palette.failure.main, backgroundColor: "transparent" }, getPaperStateStyles(theme)),
        success: Object.assign({ color: theme.palette.success.main, backgroundColor: "transparent" }, getPaperStateStyles(theme)),
    }[type];
};
const getColorStatesStyles = (color) => ({
    "&:hover": {
        backgroundColor: alpha(color, 0.1),
    },
    "&:active": {
        backgroundColor: alpha(color, 0.2),
    },
});
const getPaperStateStyles = (theme) => ({
    "&:hover": {
        backgroundColor: alpha(theme.palette.background.paper, 0.6),
    },
    "&:active": {
        backgroundColor: alpha(theme.palette.background.paper, 0.8),
    },
});

export { IconButton };
//# sourceMappingURL=IconButton.js.map
